import { useState } from 'react';
import { Container, Paper, Title, Text, Stack, Alert, Anchor } from '@mantine/core';
import { useGoogleLogin } from '../hooks/useAuth';
import { GoogleLogin } from '@react-oauth/google';
import { Link } from 'react-router-dom';

export function LoginPage() {
  const googleLogin = useGoogleLogin();
  const [error, setError] = useState<string | null>(null);

  const handleGoogleSuccess = (credentialResponse: { credential?: string }) => {
    if (!credentialResponse.credential) {
      setError('Google sign-in failed. Please try again.');
      return;
    }
    setError(null);
    googleLogin.mutate(credentialResponse.credential, {
      onError: (err: unknown) => {
        const msg = err instanceof Error ? err.message : 'Sign-in failed. Please try again.';
        setError(msg);
      },
    });
  };

  return (
    <Container size={420} my={40}>
      <Title ta="center" order={1}>Svara</Title>
      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <Stack align="center" gap="md">
          {error && (
            <Alert color="red" w="100%">
              {error}
            </Alert>
          )}
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={() => setError('Google sign-in failed. Please try again.')}
            useOneTap
          />
          <Text c="dimmed" size="xs" ta="center">
            <Anchor size="xs" component={Link} to="/admin/login" c="dimmed">
              Admin
            </Anchor>
          </Text>
        </Stack>
      </Paper>
    </Container>
  );
}

export default LoginPage;
